import React from "react";
import Slider from "react-slick"; // Import slick carousel
import "slick-carousel/slick/slick.css"; // Import slick styles
import "slick-carousel/slick/slick-theme.css";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const products = [
  { id: 1, name: "Product 1", price: "$25.00", image: "https://neo-images-1.s3.ap-northeast-2.amazonaws.com/1731310544575_450165027.png" },
  { id: 2, name: "Product 2", price: "$30.00", image: "https://neo-images-1.s3.ap-northeast-2.amazonaws.com/1731310544575_450165027.png" },
  { id: 3, name: "Product 3", price: "$15.00", image: "https://neo-images-1.s3.ap-northeast-2.amazonaws.com/1731310544575_450165027.png" },
  { id: 4, name: "Product 4", price: "$40.00", image: "https://neo-images-1.s3.ap-northeast-2.amazonaws.com/1731310544575_450165027.png" },
  { id: 5, name: "Product 5", price: "$50.00", image: "https://neo-images-1.s3.ap-northeast-2.amazonaws.com/1731310544575_450165027.png" },
  { id: 6, name: "Product 6", price: "$60.00", image: "https://neo-images-1.s3.ap-northeast-2.amazonaws.com/1731310544575_450165027.png" },
  { id: 7, name: "Product 7", price: "$70.00", image: "https://neo-images-1.s3.ap-northeast-2.amazonaws.com/1731310544575_450165027.png" },
  { id: 8, name: "Product 8", price: "$80.00", image: "https://neo-images-1.s3.ap-northeast-2.amazonaws.com/1731310544575_450165027.png" },
  { id: 9, name: "Product 9", price: "$90.00", image: "https://neo-images-1.s3.ap-northeast-2.amazonaws.com/1731310544575_450165027.png" },
  { id: 10, name: "Product 10", price: "$100.00", image: "https://neo-images-1.s3.ap-northeast-2.amazonaws.com/1731310544575_450165027.png" },
  { id: 11, name: "Product 11", price: "$110.00", image: "https://neo-images-1.s3.ap-northeast-2.amazonaws.com/1731310544575_450165027.png" },
  { id: 12, name: "Product 12", price: "$120.00", image: "https://neo-images-1.s3.ap-northeast-2.amazonaws.com/1731310544575_450165027.png" },
  { id: 13, name: "Product 13", price: "$130.00", image: "https://neo-images-1.s3.ap-northeast-2.amazonaws.com/1731310544575_450165027.png" },
  { id: 14, name: "Product 14", price: "$140.00", image: "https://neo-images-1.s3.ap-northeast-2.amazonaws.com/1731310544575_450165027.png" },
  { id: 15, name: "Product 15", price: "$150.00", image: "https://neo-images-1.s3.ap-northeast-2.amazonaws.com/1731310544575_450165027.png" },
  { id: 16, name: "Product 16", price: "$160.00", image: "https://neo-images-1.s3.ap-northeast-2.amazonaws.com/1731310544575_450165027.png" },
  { id: 17, name: "Product 17", price: "$170.00", image: "https://neo-images-1.s3.ap-northeast-2.amazonaws.com/1731310544575_450165027.png" },
  { id: 18, name: "Product 18", price: "$180.00", image: "https://neo-images-1.s3.ap-northeast-2.amazonaws.com/1731310544575_450165027.png" },
  { id: 19, name: "Product 19", price: "$190.00", image: "https://neo-images-1.s3.ap-northeast-2.amazonaws.com/1731310544575_450165027.png" },
  { id: 20, name: "Product 20", price: "$200.00", image: "https://neo-images-1.s3.ap-northeast-2.amazonaws.com/1731310544575_450165027.png" },
];

const ProductSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    // prevArrow: (
    //   <button className="slick-prev">
    //     <ArrowBackIosIcon />
    //   </button>
    // ), // Custom prev arrow
    // nextArrow: <button className="slick-next"> <ArrowForwardIosIcon/> </button>,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="product-slider" style={{ color: "white" }}>
      <Slider {...settings}>
        {products.map((product) => (
          <div key={product.id} className="product-card">
            <img src={product.image} alt={product.name} className="product-image" />
            <h4>{product.name}</h4>
            <p>{product.price}</p>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ProductSlider;
